import _ from "lodash";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { fetchGetIdentity } from "../queries/identity";

export const useIdentity = () => {
  const dispatch = useDispatch();
  const identityQuery = useQuery(["identity"], fetchGetIdentity(dispatch), {});
  const identityData = useMemo(() => _.get(identityQuery?.data, "payload.data.attributes"), [identityQuery?.data]);
  const userType = useMemo(
    () => _.get(identityQuery?.data, "payload.data.attributes.token.data.permissions"),
    [identityQuery?.data],
  );
  const user = useMemo(
    () => _.get(identityQuery?.data, "payload.data.attributes.token.data.user"),
    [identityQuery?.data],
  );
  return {
    ...identityData,
    userType,
    user,
  };
};
